import { render, staticRenderFns } from "./vip-wbook-list.vue?vue&type=template&id=3d88f896&scoped=true&"
import script from "./vip-wbook-list.vue?vue&type=script&lang=js&"
export * from "./vip-wbook-list.vue?vue&type=script&lang=js&"
import style0 from "./vip-wbook-list.vue?vue&type=style&index=0&id=3d88f896&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88f896",
  null
  
)

export default component.exports